export enum PanelContent {
  Create = 'Create',
  Customize = 'Customize',
  DeleteRuntime = 'DeleteRuntime',
  DeleteUnattachedPd = 'DeleteUnattachedPd',
  DeleteUnattachedPdAndCreate = 'DeleteUnattachedPdAndCreate',
  Disabled = 'Disabled',
  ConfirmUpdate = 'ConfirmUpdate',
  ConfirmUpdateWithDiskDelete = 'ConfirmUpdateWithDiskDelete',
  SparkConsole = 'SparkConsole',
}
